import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { FlowProvider } from './context/FlowContext'
import '@fontsource-variable/atkinson-hyperlegible-next'
import '@fontsource-variable/atkinson-hyperlegible-next/wght-italic.css'
import '@fontsource/fraunces/400.css'
import '@fontsource/fraunces/500.css'
import './theme.css'
import { initInstallPromptCapture } from './lib/use-install-prompt'
import { applyStoredTextSizeImmediately } from './lib/use-text-size'

// Aplica o tamanho de texto salvo antes da primeira pintura (anti-flash)
applyStoredTextSizeImmediately()

// Captura o convite de instalação do Chrome antes de qualquer tela montar
initInstallPromptCapture()

// Registra service worker para PWA (se disponível)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Força verificação de atualização a cada abertura do app
        reg.update()

        // Quando nova versão for detectada, recarrega automaticamente
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                window.location.reload()
              }
            })
          }
        })
      })
      .catch((err) => console.warn('SW registration failed:', err))
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FlowProvider>
          <App />
        </FlowProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
